import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import imgPoppies from 'assets/images/v3-photo-poppies.jpg';
import { FeatureRow } from './components/FeatureRow';

// TODO(SP-669) https://mindfeed.atlassian.net/browse/SP-669 — learn links
// temporarily hidden for launch. To re-enable, import `LearnLinkProps` from
// './components/LearnLink', uncomment this block, and pass
// `learnLinks={learnLinks}` to the <FeatureRow> below.
/*
const learnLinks: LearnLinkProps[] = [
  {
    label: 'Explore memory boxes',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </svg>
    ),
  },
];
*/

const Collage = () => {
  const t = useTranslations();
  return (
    <div className={styles.collage}>
      {/* Left column */}
      <div className={styles.column}>
        <div className={styles.card}>
          <div className={styles.cardHead}>
            <span className={classNames(styles.pill.base, styles.pill.q)}>
              {t('pages.home.section11.pillQuote')}
            </span>
            <span className={styles.source}>Atwood</span>
          </div>
          <div className={styles.quote}>
            &ldquo;{t('pages.home.section11.quoteAtwood')}&rdquo;
          </div>
          <div className={styles.footer}>
            <span>{t('pages.home.section11.reading')}</span>
            <span className={styles.heart}>♥ 8</span>
          </div>
        </div>

        <div className={classNames(styles.card, 'p-0')}>
          <div
            className={styles.photo}
            style={{ backgroundImage: `url(${imgPoppies.src})` }}
          />
          <div className="p-[15px]">
            <div className={classNames(styles.cardHead, 'mb-1.5')}>
              <span className={classNames(styles.pill.base, styles.pill.p)}>
                {t('pages.home.section11.pillPhoto')}
              </span>
              <span className={styles.source}>Provence</span>
            </div>
            <div className={styles.title}>
              {t('pages.home.section11.photoTitle')}
            </div>
            <div className={styles.by}>{t('pages.home.section11.photoBy')}</div>
          </div>
        </div>
      </div>

      {/* Right column (offset down) */}
      <div className={classNames(styles.column, 'mt-[30px]')}>
        <div className={styles.card}>
          <div className={styles.cardHead}>
            <span className={classNames(styles.pill.base, styles.pill.l)}>
              {t('pages.home.section11.pillLink')}
            </span>
            <span className={styles.source}>youtube.com</span>
          </div>
          <div className={styles.title}>Young and Beautiful</div>
          <div className={styles.by}>
            Lana Del Rey · {t('pages.home.section11.music')}
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardHead}>
            <span className={classNames(styles.pill.base, styles.pill.q)}>
              {t('pages.home.section11.pillQuote')}
            </span>
            <span className={styles.source}>Churchill</span>
          </div>
          <div className={styles.quote}>
            &ldquo;{t('pages.home.section11.quoteChurchill')}&rdquo;
          </div>
          <div className={styles.footer}>
            <span>{t('pages.home.section11.inspiration')}</span>
            <span className={styles.heart}>♥ 12</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Section11 = () => {
  const t = useTranslations();
  return (
    <FeatureRow
      reversed
      eyebrow={t('pages.home.section11.eyebrow')}
      title={t.rich('pages.home.section11.title', {
        highlight: (chunks) => (
          <span className="text-mf-blue marketing-dark:text-mf-coral">
            {chunks}
          </span>
        ),
      })}
      description={t('pages.home.section11.description')}
      visual={<Collage />}
    />
  );
};

const styles = {
  collage: 'grid w-full max-w-[440px] grid-cols-2 items-start gap-[14px]',
  column: 'flex flex-col gap-[14px]',
  // Light: hairline border + soft shadow; dark: borderless with the deep
  // shadow (border-0 keeps the dark card's box identical to before).
  card: classNames(
    'flex flex-col gap-[7px] rounded-[18px] bg-white p-[15px]',
    'border border-[#F0F0F0] shadow-[0_8px_22px_rgba(20,30,60,0.06)]',
    'marketing-dark:border-0 marketing-dark:shadow-[0_18px_44px_rgba(2,8,30,0.4)]',
  ),
  cardHead: 'flex items-center gap-[7px]',
  pill: {
    base: 'rounded-full px-[7px] py-[3px] text-[9px] font-bold tracking-[0.08em]',
    q: 'bg-[#FFE9F0] text-[#86314f]',
    p: 'bg-[#FDF6BB] text-[#7a6410]',
    l: 'bg-[#BDDEFF] text-[#1c4a8f]',
  },
  source: 'text-[10.5px] text-[#8a8f99]',
  quote: 'font-serif text-[15px] italic leading-[1.45] text-mf-off-black-600',
  title: 'text-sm font-bold text-mf-off-black-600',
  by: 'text-xs text-[#8a8f99]',
  photo: 'h-[120px] rounded-t-[18px] bg-cover bg-center',
  footer: 'flex justify-between text-[11px] text-[#a2a7b2]',
  heart: 'text-[#D7344A]',
};
